import { HealthEducationModule } from '../health-education/health-education.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './app-layout.component';
import { AuthenticationGuard } from '../../@core/guard/authentication.guard';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'service',
        loadChildren: () =>
          import('../service/service.module').then((m) => m.ServiceModule),
      },
      {
        path: 'marketing/:id',
        loadChildren: () =>
          import('../marketing/marketing.module').then(
            (m) => m.MarketingModule
          ),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('../about/about.module').then((m) => m.AboutModule),
      },
      {
        path: 'doctor',
        loadChildren: () =>
          import('../doctor/doctor.module').then((m) => m.DoctorModule),
      },
      {
        path: 'membership',
        loadChildren: () =>
          import('../membership/membership.module').then(
            (m) => m.MembershipModule
          ),
      },
      {
        path: 'health-education',
        loadChildren: () =>
          import('../health-education/health-education.module').then(
            (m) => m.HealthEducationModule
          ),
      },
      {
        path: 'news',
        loadChildren: () =>
          import('../new/new.module').then((m) => m.NewModule),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('../contact-us/contact-us.module').then(
            (m) => m.ContactUsModule
          ),
      },
      {
        path: 'join-us',
        loadChildren: () =>
          import('../join-us/join-us.module').then((m) => m.JoinUsModule),
      },
      {
        path: 'FAQ',
        loadChildren: () =>
          import('../faq/faq.module').then((m) => m.FAQModule),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('../account/account.module').then((m) => m.AccountModule),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'session',
        loadChildren: () =>
          import('../session/session.module').then((m) => m.SessionModule),
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () =>
          import('../terms-and-conditions/terms-and-conditions.module').then(
            (m) => m.TermsAndConditionsModule
          ),
      },
      {
        path: 'cart',
        loadChildren: () =>
          import('../cart/cart.module').then((m) => m.CartModule),
      },
      {
        path: 'bills-details',
        loadChildren: () =>
          import('../bills-details/billsdetails.module').then(
            (m) => m.BillsModule
          ),
      },
      {
        path: 'success',
        loadChildren: () =>
          import('../success/success.module').then((m) => m.SuccessModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppLayoutRoutingModule {}
